import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { E as ExtenderButton } from '../Extender/Extender-DnqZaLPo.js';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { T as TaktIdProvider } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { n as noop } from '../LocalModules/storm-ui-utils/dist/esm/noop-BNkHXPFl-BNkHXPFl.js';

const InlineExpandTriggerWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40026394__sc-1yohf31-0"
})(["display:inline-flex;"]);
const RenderEndWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40026394__sc-1yohf31-1"
})(["display:inline-block;"]);
const InlineExpanderContent = /*#__PURE__*/styled('section').withConfig({
  componentId: "sc-storm-ui-40026394__sc-1yohf31-2"
})(["display:", ";margin-block-start:", ";", ""], ({
  isOpen
}) => isOpen ? 'block' : 'none', ({
  theme
}) => theme.spacing.xxxsmall.default, isMobile(css(["margin-block-start:", ";"], ({
  theme
}) => theme.spacing.xxxsmall.mobile)));
const InlineExpander = ({
  children,
  label,
  handleClick = noop,
  isOpen,
  renderEnd,
  taktId,
  taktValue,
  ...rest
}) => /*#__PURE__*/React__default.createElement(TaktIdProvider, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('inline-expander')
}, /*#__PURE__*/React__default.createElement(InlineExpandTriggerWrapper, null, /*#__PURE__*/React__default.createElement(ExtenderButton, _extends({
  taktId: createStormTaktId(isOpen ? 'close-button' : 'open-button')
}, rest, {
  onClick: handleClick,
  isOpen: isOpen,
  label: label,
  inline: true
})), renderEnd && /*#__PURE__*/React__default.createElement(RenderEndWrapper, null, renderEnd())), /*#__PURE__*/React__default.createElement(InlineExpanderContent, _extends({}, rest, {
  isOpen: isOpen
}), children));

export { InlineExpander as I };
//# sourceMappingURL=InlineExpander-Dq-5DBYW.js.map
